/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthcareServiceModel } from '../../models/healthcare-service-model';

export interface AdminFhirIdHealthcareServiceHealthcareServiceFhirIdGet$Params {
  fhirId: string;
  healthcareServiceFhirId: string;
}

export function adminFhirIdHealthcareServiceHealthcareServiceFhirIdGet(http: HttpClient, rootUrl: string, params: AdminFhirIdHealthcareServiceHealthcareServiceFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<HealthcareServiceModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdHealthcareServiceHealthcareServiceFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('healthcareServiceFhirId', params.healthcareServiceFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<HealthcareServiceModel>;
    })
  );
}

adminFhirIdHealthcareServiceHealthcareServiceFhirIdGet.PATH = '/Admin/{fhirId}/HealthcareService/{healthcareServiceFhirId}';
